module.exports = __webpack_public_path__ + "img/download-03.4e9f3267.svg";